import { Fragment, ReactElement, useMemo } from 'react';
import { CitizenshipRegistrationNotificationsCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CitizenshipRegistrationNotificationsSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CitizenshipRegistrationNotificationsMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CitizenshipRegistrationNotificationsCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CitizenshipRegistrationNotificationsCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import RegistrationCitizenshipNotificationShared from 'shell/components/shared/research-notifications/research-citizenship/detail';

interface RegistrationCitizenshipNotificationCivilStatusSharedProps {
  scope?: string;
}

const RegistrationCitizenshipNotificationCivilStatusShared = ({
  scope,
}: RegistrationCitizenshipNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return CitizenshipRegistrationNotificationsCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CitizenshipRegistrationNotificationsCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CitizenshipRegistrationNotificationsSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CitizenshipRegistrationNotificationsMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CitizenshipRegistrationNotificationsCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <RegistrationCitizenshipNotificationShared
        goBackUrl={goBackUrl}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isNotDisabledCitizenship={Boolean(idCat)}
      />
    </Fragment>
  );
};

RegistrationCitizenshipNotificationCivilStatusShared.displayName =
  'Registration Citizenship Notification Page component';

export default RegistrationCitizenshipNotificationCivilStatusShared;
